import { Injectable, Inject } from '@angular/core';
import * as signalR from "@microsoft/signalr";
import { Settings } from '../models/settings';
import { SettingService } from './setting.service';
import { CustomMessageService } from './custom.message.service';
import { ApiResponse } from '../models/apiResponse';
import { MessagType } from '../models/messagType';
import { ResetService } from './reset.service';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {  
  constructor(@Inject(SettingService) public settings: Settings, private resetService: ResetService, private customMessageService: CustomMessageService) { }

  public static SignalRConnectionId: string;
  public responseServerToClient: any;
  public bradcastedData: any;
  public hubConnection: signalR.HubConnection;
  //public hubConnectionAzureFunction: signalR.HubConnection;
    
  public startWebAppConnection = () => {   
    this.hubConnection = new signalR.HubConnectionBuilder()
                            .withUrl(this.settings.webAppApiUrl, { skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets })
                            .build();
    this.hubConnection.serverTimeoutInMilliseconds = 54000000;
    this.hubConnection
      .start()
      .then(() => {
         console.log('Connection started');
         this.hubConnection.invoke('getConnectionId')
                .then(function (signalRConnectionId) {
                    SignalRService.SignalRConnectionId = signalRConnectionId;
                    //sessionStorage.setItem('signalRConnectionId', signalRConnectionId);                  
                }).catch(err => console.error(err.toString())) 
      }).catch(err => console.log('Error while starting connection: ' + err))
  }    

  public getSignalRConnectionId(): Promise<string> {      
    this.hubConnection = new signalR.HubConnectionBuilder()
                            .withUrl(this.settings.webAppApiUrl, { skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets })
                            .build();
    this.hubConnection.serverTimeoutInMilliseconds = 54000000;
    return this.hubConnection
      .start()
      .then(() => {
         console.log('Connection started');
         return this.hubConnection.invoke('getConnectionId')
                .then(function (signalRConnectionId) {                
                  return signalRConnectionId;                              
                }).catch(err => {
                    console.error(err.toString());
                    })             
      }).catch((err: any) => { 
          console.log('Error while starting connection: ' + err);       
          return err;});     
  }

  public addResponseServerToClientListener = () => {
    this.hubConnection.on('responseServerToClient', (apiResponse: ApiResponse) => {  
      if(apiResponse.msgType == MessagType.MarkerData) {       
          this.resetService.resetDataCommunicate({Type: ResetService.Marker, Data: apiResponse.data})
      }
      else {
        this.customMessageService.showMessage({'severity': apiResponse.msgType, summary: apiResponse.summary, detail: apiResponse.message}); 
      }
     });
  }

  public broadcastChartData = () => {
    this.hubConnection.invoke('broadcastchartdata', this.responseServerToClient)
    .catch(err => console.error(err));
  }

  public addBroadcastChartDataListener = () => {
    this.hubConnection.on('broadcastchartdata', (data) => {
      this.bradcastedData = data;
    })
  }
  
   // public startAzureFunctionConnection = () => {   
  //   this.hubConnectionAzureFunction = new signalR.HubConnectionBuilder()
  //                          // .withUrl(this.settings.apiFunctionUrl, { skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets })
  //                           .withUrl(this.settings.apiFunctionUrl)
  //                           .build();
  //   this.hubConnectionAzureFunction.serverTimeoutInMilliseconds = 54000000;
  //   this.hubConnectionAzureFunction
  //     .start()
  //     .then(() => {
  //        console.log('Azure Function Connection started');
  //        this.hubConnectionAzureFunction.invoke('getConnectionId')
  //               .then(function (signalRConnectionId) {
  //                   sessionStorage.setItem('signalRConnectionId', signalRConnectionId);                  
  //               }).catch(err => console.error(err.toString())) 
  //     }).catch(err => console.log('Azure Function Connection Error while starting connection: ' + err))
  // }    
}